export default __webpack_public_path__ + "static/media/project2.c8b92737.jpg";